import { render, staticRenderFns } from "./serve-new.vue?vue&type=template&id=503f14a1&scoped=true&"
import script from "./serve-new.vue?vue&type=script&lang=js&"
export * from "./serve-new.vue?vue&type=script&lang=js&"
import style0 from "./serve-new.vue?vue&type=style&index=0&id=503f14a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f14a1",
  null
  
)

export default component.exports